<template>
    <div class="partner _page" style="padding-bottom: 0">
        <l-banner v-bind='bannerConf'></l-banner>

        <img src="@/assets/img/js/0.png"/>
        <img src="@/assets/img/js/1.png"/>
        <img src="@/assets/img/js/2.png"/>
        <img src="@/assets/img/js/3.png"/>
        <img src="@/assets/img/js/4.png"/>
        <img src="@/assets/img/js/5.png"/>
        <img src="@/assets/img/js/6.png"/>
        <img src="@/assets/img/js/7.png"/>

    </div>
</template>

<script>
import banner from '@/assets/img/banner5_bg@2x.png'
import tipImg from '@/assets/img/photos@2x.png'

export default {
    data() {
        return {
            bannerConf: {
                title: '中科德诺 · 物联网低功耗微传感芯片SoC',
                subTitle: 'DNG · AIoT SoC .',
                slogan: '—— 一家人工智能物联网传感企业 ——',
                src: banner
            },
            tipImg
        }
    }

}
</script>
<style lang="scss" scoped>

.partner {
    padding-bottom: 100px;
}

.title {
    margin: 110px auto 32px;
    text-align: center;
    font-size: $font_size_sub_title;
}

.img {
    margin: auto;
}
</style>
